// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "c996f9ad75e3455df9ed96e2fb5c5e8e36ad0f77/static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"440":"486bdddc","581":"0843d95a","688":"2b6b0509","774":"24c5a21d"}[chunkId] + ".chunk.js";
};